/*
 *  Product waitlist notify
 *
 *
 *  Version:
 *    1.0.0 - 2020/09/03
 */
import { backInStockForm } from '../../objects/product/BackInStock';
var BIS_FORM = '[data-bis]';
var BIS_FORM_CONTAINER = '[data-bis-container]';
var BIS_SUBMIT_BUTTON = '[data-bis-submit]';
var SUBMIT_MESSAGE_DEFAULT_SELECTOR = '[data-bis-message-default]';
var SUBMIT_MESSAGE_SUCCESS_SELECTOR = '[data-bis-message-success]';
var SUBMIT_MESSAGE_ERROR_SELECTOR = '[data-bis-message-error]';
var onButtonSubmitWaitlistNotify = function onButtonSubmitWaitlistNotify(e) {
  e.preventDefault(); // Prevent the form from submitting via the browser
  e.stopPropagation();
  var form = $(BIS_FORM);
  var formContainer = $(BIS_FORM_CONTAINER);
  backInStockForm(form, formContainer, SUBMIT_MESSAGE_DEFAULT_SELECTOR, SUBMIT_MESSAGE_SUCCESS_SELECTOR, SUBMIT_MESSAGE_ERROR_SELECTOR);
};
$(function () {
  $(document).on('click touchend', BIS_SUBMIT_BUTTON, function (e) {
    return onButtonSubmitWaitlistNotify(e);
  });
});